import http from "../../utils/http-common";

export interface ServiceProcedureCreateData {
  title: string;
  procedure: number;
  agents: string[];
}

export const createServiceProcedure = async (
  data: ServiceProcedureCreateData
) => {
  const response = await http.post("/service_procedure", data);
  return response.data;
};
